module.exports = __webpack_public_path__ + "assets/img/title-55f4e0cc.png";